import { TrashIcon } from '@heroicons/react/outline';

import { Button, ConfirmationDialog } from '@/components/Elements';
import { Authorization, ROLES } from '@/lib/authorization';
import Delete from '@/assets/img/delete-icon.svg';
import { useDeleteLocation } from '../api/deleteLocation';
import { Location } from '../types';
import { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
export type DeleteDialogProps = {
  location: Location;
  onDelete: () => void;
};
export const DeleteLocation = ({ location, onDelete }: DeleteDialogProps) => {
  const deleteLocationMutation = useDeleteLocation();
  const [isDone, setIsDone] = useState(false);
  return (
    <div className="">
      <ConfirmationDialog
        isDone={ isDone }
        icon="danger"
        title="Delete Location"
        body="Are you sure you want to delete this location?"
        triggerButton={
          <Dropdown.Item className="menu-btn">
            <div className="menu-btn-child">
              <img src={ Delete } className="delete-icon" /> Delete
            </div>
          </Dropdown.Item>
        }
        confirmButton={
          <Button
            isLoading={ deleteLocationMutation.isLoading }
            type="button"
            className="bg-red-600"
            onClick={ async () => {
              await deleteLocationMutation.mutateAsync({ data: location });
              onDelete();
              setIsDone(true);
              setIsDone(false);
            } }
          >
            Delete Location
          </Button>
        }
      />
    </div>
  );
};
